import { EditIcon } from "@/icons";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { SectionMappingWidget } from "./section-mapping";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { useTheme } from "@/contexts/theme";
const AccordionMappingWidget = ({
  expanded,
  index,
  classes,
  handleChange,
  subSection,
  onOpenModal,
  section,
  updatedProductParameterHidden,
  updatedProductParameterAiSuggestion,
  updatedProductParameteRequierd,
  updatedProductParameteLocked,
  _renderParameterType,
  relatedParameters,
  updatedProductParameterShowToClient,
  onOpenExternalIdsModal,
  getProductById,
  removeProductParamete,
  saveTemplateParameterSettings,
  updatedProductParameterTranslations,
  queueAddExistingParameterToTemplate,
  onEditSubSection,
  deleteSubSectionFromTemplate,
  isVariationProductMode,
  onOpenColorOptionsModal,
  onOpenRollDirectionOptionsModal,
}) => {
  const { primaryColor } = useGomakeTheme();
  const isModern = useTheme().currentTheme === "modern";
  const [actionsEl, setActionsEl] = useState<HTMLDivElement | null>(null);
  return (
    <Accordion
      className={isModern ? "gm-pc-card" : undefined}
      expanded={expanded === `panel_${index}`}
      onChange={handleChange(`panel_${index}`)}
      key={index}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        style={
          expanded === `panel_${index}` ? classes.activeTabContainer : null
        }
      >
        <div style={{ ...classes.headerAccordionContainer, width: "100%", display: "flex", alignItems: "center" }}>
          {expanded === `panel_${index}` ? (
            <EditIcon stroke={primaryColor(900)} />
          ) : (
            <EditIcon stroke={primaryColor(400)} />
          )}

          <div
            style={
              expanded === `panel_${index}`
                ? classes.subSectionAccordionActiveStyle
                : classes.subSectionAccordionStyle
            }
          >
            {subSection.name}
          </div>
          <div
            ref={setActionsEl}
            onClick={(event) => event.stopPropagation()}
            onMouseDown={(event) => event.stopPropagation()}
            style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
          />
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <SectionMappingWidget
          index={index}
          classes={classes}
          subSection={subSection}
          onOpenModal={onOpenModal}
          onOpenExternalIdsModal={onOpenExternalIdsModal}
          section={section}
          updatedProductParameterHidden={updatedProductParameterHidden}
          updatedProductParameterAiSuggestion={
            updatedProductParameterAiSuggestion
          }
          updatedProductParameteRequierd={updatedProductParameteRequierd}
          _renderParameterType={_renderParameterType}
          relatedParameters={relatedParameters}
          updatedProductParameteLocked={updatedProductParameteLocked}
          updatedProductParameterShowToClient={
            updatedProductParameterShowToClient
          }
          getProductById={getProductById}
          removeProductParamete={removeProductParamete}
          saveTemplateParameterSettings={saveTemplateParameterSettings}
          updatedProductParameterTranslations={updatedProductParameterTranslations}
          queueAddExistingParameterToTemplate={queueAddExistingParameterToTemplate}
          onEditSubSection={onEditSubSection}
          deleteSubSectionFromTemplate={deleteSubSectionFromTemplate}
          isVariationProductMode={isVariationProductMode}
          onOpenColorOptionsModal={onOpenColorOptionsModal}
          onOpenRollDirectionOptionsModal={onOpenRollDirectionOptionsModal}
          insideAccordion={isModern}
          accordionActionsEl={actionsEl}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export { AccordionMappingWidget };
